define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/action/ActionView",
	"csi/def",
	"csi/def/Field",
	"csi/locale",
	"csi/def/ViewFactory",
	"csi/form/Widget",
	"csi/types",
	"./AttributeController",
	"csi/xml"
], function(declare,lang,ActionView,def,Field,locale,ViewFactory,FormWidget,types,AttributeController,xml) {
	
	var SITE_ADDRESS = "WebsiteAddress";
	var SITE_NAME = "WebsiteText";

	var _Form = declare(FormWidget, {
		// attach points
		addressNode: null,
		nameNode: null,

		// String: initial value for address
		defaultAddress: "https://",

		// Boolean: name should track address until name is changed directly by user
		_bNameChange: false,
		
		addDefaultValue: function(/*String*/name, /*Any*/value) {
			if(name == SITE_ADDRESS) {
				this._bNameChange = (value != this._getAddressName(value));
				value = value || this.defaultAddress;
			}
			this.inherited(arguments, [name, value]);

		},

		onChangeName: function(/*Object*/value) {
			// summary: track name changes so that changes to address will not overwrite changes to name
			this._bNameChange = !!value;
		},
		
		onChangeAddress: function(/*Object*/value) {
			// summary: update name field unless it has been explicitly set
			if (!value) {
				value = this.defaultAddress;
				this.setFieldValue(SITE_ADDRESS, value);
				this._bNameChange = false;
			}

			if (!this._bNameChange) {
				this.setFieldValue(SITE_NAME, this._getAddressName(this.getFieldValue(SITE_ADDRESS)));
			}
		},
		
		onChangeName: function(/*Object*/value) {
			// summary: track name changes so that changes to address will not overwrite changes to name
			this._bNameChange = !!value;
		},

		_getAddressName: function(/*String*/address) {
			// summary: remove prefix from href
			return address.replace(xml.RE_WEB, "");
		}
		
	});
	
	return declare(AttributeController, {
		
		getActionView: function(/*ViewRef?*/vr) {
			//var	defView = def.getNodeViewDef(nodeReferenced, idView, false, false, typeView);
			var defView = ViewFactory.create(null, 'Form');
			defView.classController = _Form;
			defView.m_id = "__StringUrlForm__";
			
			defView.addField(lang.mixin(new Field(), {
				m_label: SITE_ADDRESS,
				m_type: xml.ATTR_STRING,
				m_onChange: "onChangeAddress",
				widgetParams: {
					regExp: "^(http://|https://|ftp://).*",
					invalidMessage: locale.resource("WebsiteInvalid")
				}
			}));
			
			defView.addField(lang.mixin(new Field(), {
				m_label: SITE_NAME,
				m_type: xml.ATTR_STRING,
				m_onChange: "onChangeName"
			}));
			
			return new ActionView(this, defView, this.getNode());
		},

		process: function() {
			var value = this._popupDialog.value;
			this.newValue = types.serializeHyperlink(value.WebsiteText, value.WebsiteAddress);
			this.inherited(arguments);
		},
		
		getStringParameters: function() {
			// summary: parameterize dialog title with heading name
			return [this.heading.m_name];
		},
		
		onCreatePopup: function(/*csi.view.Widget*/view) {
			// summary: initialize custom attribute form with business object node
			var parsedValue = types.parseSerializedHyperlink(this.oldValue);
			view.addDefaultValue(SITE_NAME, parsedValue.name || "");
			view.addDefaultValue(SITE_ADDRESS, parsedValue.addr || "");
			this.inherited(arguments);
		}
	});
});